module.exports = __webpack_public_path__ + "static/img/fkl.06cffa96.png";